// Tipovi i konstante
// import { SettingDetailPageCmp, SettingDetailPageProps } from "./types";
import { CALCULATION_SETTING_PAGE_TITLE } from "ui/components/PageTitle/consts";
import { BreadcrumbItem } from "ui/components/Breadcrumb/types";
import { SIDEBAR_ITEM_CALCULATION_SETTING } from "app/components/Sidebar/consts";

// UI komponente
import { Breadcrumb } from "ui/components/Breadcrumb";
import { PageHeader } from "ui/components/PageHeader";
import { PageTitle } from "ui/components/PageTitle";

// Moduli specifični za projekt
import { Routes } from "../../navigation";
import TabMenu from "./components/TabMenu/TabMenu";
import { SettingPageCmp, SettingPageProps } from "./types";
import SettingDetailCard from "./components/SettingDetailCard/SettingDetailCard";

const SettingPage: SettingPageCmp = (props: SettingPageProps) => {
  const title = CALCULATION_SETTING_PAGE_TITLE;

  const breadcrumbs: BreadcrumbItem[] = [
    {
      text: SIDEBAR_ITEM_CALCULATION_SETTING.text,
      route: SIDEBAR_ITEM_CALCULATION_SETTING.route,
    },
  ];

  return (
    <>
      <div className="">
        <div className="bg-white rounded-t-md">
          <PageHeader>
            <PageTitle
              title={`${title.text}`}
              icon={title.icon}
              iconColor={title.iconColor}
            />
            <Breadcrumb items={breadcrumbs} />
          </PageHeader>
          <TabMenu />
        </div>
        <div className="px-4 py-4">
          <SettingDetailCard />
        </div>
      </div>
    </>
  );
};

SettingPage.route = Routes.CalculationSettingPageRouter;

export default SettingPage;
